import React from 'react';
import { tokens as defaultTokens } from '../tokens';

export default function ActionLink({ children, onClick, tokens = defaultTokens, trailing = '\u2192' }) {
  const [hov, setHov] = React.useState(false);
  return (
    <button
      className="gl-btn-bare"
      onClick={onClick}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        display: 'flex', alignItems: 'baseline', gap: 14,
        padding: '12px 0',
        fontFamily: tokens.fontDisplay,
        fontSize: tokens.displayMd,
        fontWeight: tokens.displayWeight,
        letterSpacing: tokens.displayTracking,
        color: hov ? tokens.accent : tokens.textHi,
        transition: `color 400ms ${tokens.ease}`,
        width: '100%',
        borderBottom: `1px solid ${tokens.edge}`,
      }}
    >
      <span style={{ flex: 1 }}>{children}</span>
      <span style={{
        fontFamily: tokens.fontMono,
        fontSize: 14,
        color: hov ? tokens.accent : tokens.textLow,
        transform: hov ? 'translateX(4px)' : 'translateX(0)',
        transition: `all 400ms ${tokens.ease}`,
      }}>{trailing}</span>
    </button>
  );
}
